import { withInstall } from '@tav-ui/utils/with-install'
import ContainerCollapse from './src/container-collapse.vue'
const TaContainerCollapse = withInstall(ContainerCollapse)
export { TaContainerCollapse }
export default TaContainerCollapse
export * from './src/types'
